const nameValidation = (name) => name && name.replace(/\s/g, "").length > 0;
const ipsFormatValidation = (ips) => {
  const ipv4Regex = /^(\d{1,3}\.){3}\d{1,3}$/;
  const ipv6Regex = /(?:^|(?<=\s))(([0-9a-fA-F]{1,4}:){7,7}[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,7}:|([0-9a-fA-F]{1,4}:){1,6}:[0-9a-fA-F]{1,4}|([0-9a-fA-F]{1,4}:){1,5}(:[0-9a-fA-F]{1,4}){1,2}|([0-9a-fA-F]{1,4}:){1,4}(:[0-9a-fA-F]{1,4}){1,3}|([0-9a-fA-F]{1,4}:){1,3}(:[0-9a-fA-F]{1,4}){1,4}|([0-9a-fA-F]{1,4}:){1,2}(:[0-9a-fA-F]{1,4}){1,5}|[0-9a-fA-F]{1,4}:((:[0-9a-fA-F]{1,4}){1,6})|:((:[0-9a-fA-F]{1,4}){1,7}|:)|fe80:(:[0-9a-fA-F]{0,4}){0,4}%[0-9a-zA-Z]{1,}|::(ffff(:0{1,4}){0,1}:){0,1}((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])|([0-9a-fA-F]{1,4}:){1,4}:((25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9])\.){3,3}(25[0-5]|(2[0-4]|1{0,1}[0-9]){0,1}[0-9]))(?=\s|$)/;
  return ips.every((ip) => ipv4Regex.test(ip) || ipv6Regex.test(ip));
};
const hostnamesFormatValidation = (hostnames) => hostnames.every((hostname) => hostname && !hostname.match(/\s/g));
const macsFormatValidation = (macs) => {
  const macRegex = /^([0-9A-Fa-f]{2}[:-]?){5}([0-9A-Fa-f]{2})$/;
  return macs.every((mac) => macRegex.test(mac));
};
const ipsHostsMacsRequiredValidation = (ips, hostnames, macs) => ips.length > 0 || hostnames.length > 0 || macs.length > 0;
export function validations(values) {
  const errors = {};
  const { ip_addresses, hostnames, mac_addresses } = values.details;
  if (!nameValidation(values.name)) errors.name = "Asset Name is required";
  if (!ipsHostsMacsRequiredValidation(ip_addresses, hostnames, mac_addresses)) {
    errors.details = {
      ip_addresses: "At least one IP, hostname, or MAC address is required",
      hostnames: "At least one IP, hostname, or MAC address is required",
      mac_addresses: "At least one IP, hostname, or MAC address is required"
    };
  } else {
    if (!ipsFormatValidation(ip_addresses))
      errors.details = { ...errors.details || {}, ip_addresses: "Invalid IP address format" };
    if (!hostnamesFormatValidation(hostnames))
      errors.details = { ...errors.details || {}, hostnames: "Invalid hostname format" };
    if (!macsFormatValidation(mac_addresses))
      errors.details = { ...errors.details || {}, mac_addresses: "Invalid MAC address format" };
  }
  return errors;
}
